<div class="page-search mb-footer">
    <div class="bg-search" 
        [ngStyle]="{'background-image' : 'url('+ '../../../assets/images/banner/bg-search.jpg' +')'}">
        <div class="container">
            <div class="row">
                <div class="col-xl-7 col-lg-8 col-md-9 mx-auto">
                    <div class="form-search position-relative">
                        <input type="text" 
                                class="form-control" 
                                placeholder="Search..." 
                                [formControl]="search" 
                                (keydown)="onSearch($event)">
                        <span class="ic-search pointer" (click)="onSearch($event)">
                            <i class="icon ion-md-search"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="result">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h6 class="s-tit tit-f18b">{{ isLang?.searchResult }}</h6>
                    <div class="row">
                        <div class="col-xl-7 col-lg-8 col-md-9 px-lg-4 px-xl-5 mx-auto">
                            <!-- news release -->
                            <div *ngIf="searchResultNews.length != 0 && !loading">
                                <a class="d-block w-result my-3" 
                                   *ngFor="let data of searchResultNews"
                                   [routerLink]="'/news-and-events/'+data?.category.slug+'/'+data?.seotitle">
                                    <div class="d-flex justify-content-between">
                                        <div class="w-75 pr-3"> 
                                            <h6 class="tit-f18b tit-r">{{ data.title }}</h6>
                                            <div class="detail mt-3" *ngIf="data.content" [innerHTML]="globalService.trimString2(data.content, 150)"></div>
                                        </div>
                                        <div class="w-25 text-right">
                                            <small>{{ data.category.title }}</small>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <!-- menu -->
                            <div *ngIf="searchResultMenu.length != 0 && !loading">
                                <a class="d-block w-result my-3" 
                                    *ngFor="let data of searchResultMenu"
                                    [routerLink]="'/'+data.parent+'/'+data?.link">
                                    <div class="d-flex justify-content-between">
                                        <div class="w-75 pr-3"> 
                                            <h6 class="tit-f18b tit-r">{{ data.title }}</h6>
                                            <div class="detail mt-3" *ngIf="data.metadesc" [innerHTML]="globalService.trimString2(data.metadesc, 150)"></div>
                                        </div>
                                        <div class="w-25 text-right">
                                            <small>{{ data.parent_name }}</small>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <!-- sections -->
                            <div *ngIf="searchResultSection.length != 0 && !loading">
                                <a class="d-block w-result my-3" 
                                   *ngFor="let data of searchResultSection"
                                   [routerLink]="'/'+data.parent+'/'+data.menu">
                                    <div class="d-flex justify-content-between">
                                        <div class="w-75 pr-3"> 
                                            <h6 class="tit-f18b tit-r">{{ data.title }}</h6>
                                            <div class="detail mt-3" *ngIf="data.content" [innerHTML]="globalService.trimString2(data.content, 150)"></div>
                                        </div>
                                        <div class="w-25 text-right">
                                            <small>{{ data.menu_name }}</small>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <!-- not found search -->
                            <div class="w-result text-center my-3" 
                                *ngIf="searchResultNews.length == 0 && 
                                        !loading && 
                                        searchResultSection.length == 0 && 
                                        searchResultMenu.length == 0 &&
                                        keyword">
                                <h5 class="mb-0">{{ isLang.noDataSearch }}</h5>
                            </div>
                            <div class="text-center mt-5" *ngIf="loading">
                                <div class="spinner-border text-dark" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
